import { equipmentAccessorialSchema } from '../equipment/accessorials.ts'
import {
  vArray,
  vBoolean,
  vBoolStrict,
  vMinLength,
  vObject,
  vObjectId,
  vOptional,
  vOptionalDef,
  type vOutput,
  vPicklist,
  vPipe,
  vString,
} from '../validation/index.ts'
import { billToSchema } from './account-bill-to.ts'
import { retenderReasons } from './book.ts'
import { baseCustomsBrokerSchema } from './customs-broker.ts'
import { deliveryOptionSchema } from './delivery-option.ts'
import { emergencyContactSchema } from './emergency-contact.ts'
import { holdAtLocationSchema } from './hold-at-location.ts'
import { loadHandlingUnitSchema } from './load-handling-unit.ts'
import { apiLoadLocationSchema } from './load-location.ts'
import { loadNotificationSchema } from './load-notification.ts'
import { shareSchema } from './share.ts'

export const awardLoadEntrySchema = vObject({
  loadId: vObjectId(),
  quoteId: vObjectId(),
  items: vOptional(vArray(loadHandlingUnitSchema)),
  equipment: vOptional(
    vObject({
      accessorials: vOptional(vArray(equipmentAccessorialSchema)),
    }),
  ),
  notifications: vOptional(vArray(loadNotificationSchema)),
  holdAtLocation: vOptional(holdAtLocationSchema),
  deliveryOption: vOptional(deliveryOptionSchema),
})

const commonAwardLoadsSchemaFields = {
  loads: vArray(awardLoadEntrySchema),
  locations: vPipe(vArray(apiLoadLocationSchema), vMinLength(2)),
  createBOL: vOptionalDef(vBoolStrict(), true),
  customsBroker: vOptional(vArray(baseCustomsBrokerSchema)),
  emergencyContact: vOptional(emergencyContactSchema),
  billTo: vOptional(billToSchema),
  shares: vOptional(vArray(shareSchema)),
  rateLocationType: vOptional(vPicklist(['origin', 'destination'])),
  glCode: vOptional(vString()),
  brandId: vOptional(vObjectId()),
}

export const createLoadsSchema = vObject({
  ...commonAwardLoadsSchemaFields,
  schedulePickup: vOptionalDef(vBoolStrict(), true),
  tags: vOptional(vArray(vString())),
  bolNumber: vOptional(vString()),
})

export const editLoadsSchema = vObject({
  ...commonAwardLoadsSchemaFields,
  bolNumber: vOptional(vString()),
  retender: vOptional(vBoolean()),
  retenderReason: vOptional(vPicklist(retenderReasons)),
})

export type AwardLoadEntryDTO = vOutput<typeof awardLoadEntrySchema>
export type CreateLoadsDTO = vOutput<typeof createLoadsSchema>
export type EditLoadsDTO = vOutput<typeof editLoadsSchema>
